<template>
  <el-dialog
    title="撤回收货"
    custom-class="void-receipt-dialog"
    :visible.sync="dialogVisible"
    width="960px"
    :close-on-click-modal="false"
    append-to-body
    @close="handleClose"
  >
    <div class="void-tip">
      作废生效收货单后按剩余生效单重算；若无最终收货，待收货回到待收货，待下单/待支付保持原状态。已发起退款/退货的单不可撤回。
    </div>
    <el-table
      :data="receiptList"
      border
      stripe
      size="mini"
      max-height="480"
      v-loading="loading"
      element-loading-text="加载中..."
      class="receipt-list-table"
    >
      <el-table-column type="index" label="序号" width="48" align="center"></el-table-column>
      <el-table-column prop="orderNo" label="采购单号" min-width="150" show-overflow-tooltip></el-table-column>
      <el-table-column prop="receiptNo" label="收货单号" min-width="150" show-overflow-tooltip></el-table-column>
      <el-table-column prop="receiptTypeLabel" label="类型" width="90" align="center"></el-table-column>
      <el-table-column prop="lineCount" label="明细行数" width="80" align="right"></el-table-column>
      <el-table-column prop="createUser" label="创建人" width="90" show-overflow-tooltip></el-table-column>
      <el-table-column prop="createTimeLabel" label="创建时间" width="160"></el-table-column>
      <el-table-column label="状态" width="80" align="center">
        <template slot-scope="scope">
          <span :class="scope.row.voided ? 'status-voided' : 'status-effective'">
            {{ scope.row.voided ? "已作废" : "生效" }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="voidReason" label="作废原因" min-width="120" show-overflow-tooltip>
        <template slot-scope="scope">{{ scope.row.voidReason || "-" }}</template>
      </el-table-column>
      <el-table-column label="操作" width="90" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.canVoid"
            type="text"
            size="mini"
            class="void-btn"
            :loading="voidingId === scope.row._id"
            @click="onVoid(scope.row)"
          >
            作废
          </el-button>
          <span v-else class="op-empty">-</span>
        </template>
      </el-table-column>
    </el-table>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" size="small" @click="dialogVisible = false">关 闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { requestModules } from "@r";

export default {
  name: "VoidReceiptDialog",
  data() {
    return {
      dialogVisible: false,
      loading: false,
      receiptList: [],
      selectedList: [],
      voidingId: "",
      changed: false,
    };
  },
  methods: {
    open(selectedList) {
      this.dialogVisible = true;
      this.receiptList = [];
      this.selectedList = selectedList || [];
      this.changed = false;
      this.loadReceipts();
    },
    formatTime(ts) {
      if (!ts) return "-";
      const d = new Date(Number(ts));
      if (Number.isNaN(d.getTime())) return "-";
      if (typeof d.format === "function") {
        return d.format("yyyy-MM-dd hh:mm:ss");
      }
      const pad = n => String(n).padStart(2, "0");
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(
        d.getSeconds()
      )}`;
    },
    loadReceipts() {
      this.loading = true;
      requestModules
        .fetchPurchaseOrderReceipts({
          selectedList: JSON.stringify(this.selectedList),
        })
        .then(res => {
          if (res.result !== 1) {
            this.$message.error(res.message || "获取收货单失败");
            this.dialogVisible = false;
            return;
          }
          this.receiptList = (res.ldata || []).map(row => ({
            ...row,
            createTimeLabel: this.formatTime(row.createTime),
          }));
          if (!this.receiptList.length) {
            this.$message.info("所选采购单没有收货单");
          }
        })
        .catch(() => {
          this.$message.error("获取收货单失败");
          this.dialogVisible = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onVoid(row) {
      if (!row || !row.canVoid) return;
      this.$prompt("请填写作废原因", "作废收货单", {
        confirmButtonText: "确定作废",
        cancelButtonText: "取消",
        inputType: "textarea",
        inputPlaceholder: "例如：收货数量录入错误，需重新收货",
        inputValidator: value => {
          if (!value || !String(value).trim()) return "作废原因不能为空";
          return true;
        },
      })
        .then(({ value }) => {
          this.voidingId = row._id;
          return requestModules.voidPurchaseOrderReceipt({
            receiptId: row._id,
            reason: String(value).trim(),
          });
        })
        .then(res => {
          if (!res) return;
          if (res.result !== 1) {
            this.$message.error(res.message || "作废收货单失败");
            return;
          }
          this.$message.success("已作废收货单并重算采购单状态");
          this.changed = true;
          this.loadReceipts();
        })
        .catch(err => {
          if (err === "cancel" || (err && err === "close")) return;
          if (err && err.message) return;
          this.$message.error("作废收货单失败");
        })
        .finally(() => {
          this.voidingId = "";
        });
    },
    handleClose() {
      this.receiptList = [];
      this.selectedList = [];
      if (this.changed) {
        this.$emit("success");
      }
      this.changed = false;
    },
  },
};
</script>

<style lang="scss">
.void-receipt-dialog {
  .el-dialog__body {
    padding: 12px 16px;
  }

  .void-tip {
    margin-bottom: 10px;
    color: #909399;
    font-size: 12px;
    line-height: 1.4;
  }

  .receipt-list-table {
    width: 100%;
  }

  .status-effective {
    color: #67c23a;
  }

  .status-voided {
    color: #909399;
  }

  .void-btn {
    color: #f56c6c;
  }

  .op-empty {
    color: #c0c4cc;
  }
}
</style>
